import{fetch as r,getEndPoint as i}from"@liff/server-api";function e(){return r(i("friendship"))}export{e as getFriendship};
